import { clearStorage } from '../infra/http';
import { LoginRequest } from '@/models/user.model';
import { BaseResponseModel } from "@/models/core.model";
import { LoginResponse } from "@/models/user.model";
import axios from "axios";
import { createUrl, getReq, isStoredJwt } from '@/infra/http';


const API_URL = process.env.REACT_APP_API_URL;

export const login = async (
    input: LoginRequest
): Promise<BaseResponseModel<LoginResponse>> => {
    return await axios
        .post(API_URL + "/auth/admin/login", input)
        .then((res: any) => res.data);
};

export const logout = () => {
    clearStorage();
};

export const getCurrentUser = () => {
    const userStr = localStorage.getItem("user");
    if (userStr != null) return JSON.parse(userStr);

    return null;
};

export const me = async (): Promise<BaseResponseModel<LoginResponse>> => {
    return isStoredJwt()
        ? (await getReq(createUrl("a/profile/me")).catch(() => null))?.data
        : null;
};